<template>
  <div>
    <HeaderCampagne :currentCampagne="currentEntretienCollectif.campagne" />
    <div class="row">
      <div class="col-md-12">
        <table
          class="card table table-sm table-custom-primary table-bordered mb-0"
        >
          <tbody>
            <tr class="d-flex font-size-17 font-weight-bold">
              <td class="col-9">
                Fiche d'entretien de l'employé :
                {{
                  currentEntretienCollectif.employe.prenom
                    ? currentEntretienCollectif.employe.prenom +
                      ' ' +
                      currentEntretienCollectif.employe.nom
                    : currentEntretienCollectif.employe.nom
                }}
              </td>
              <td class="col-3">
                Statut :
                <i
                  class="mdi mdi-checkbox-blank-circle mr-1"
                  :class="getClassOfEntretien(currentEntretienCollectif.statut)"
                ></i>
                {{ getStatutEntretien(currentEntretienCollectif.statut) }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderCampagne from '@/views/rh/entretien/campagne_entretien/components/Header.vue';
export default {
  data() {
    return {};
  },

  components: {
    HeaderCampagne,
  },
  props: {
    currentEntretienCollectif: {
      require: true,
      type: Object,
    },
  },
};
</script>
